import(/* webpackMode: "eager" */ "/home/node/node_modules/@chakra-ui/react/dist/esm/components/box/box.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/node/node_modules/@chakra-ui/react/dist/esm/components/button/button.js");
;
import(/* webpackMode: "eager" */ "/home/node/node_modules/@chakra-ui/react/dist/esm/components/flex/flex.js");
;
import(/* webpackMode: "eager", webpackExports: ["GridItem"] */ "/home/node/node_modules/@chakra-ui/react/dist/esm/components/grid/grid-item.js");
;
import(/* webpackMode: "eager", webpackExports: ["Grid"] */ "/home/node/node_modules/@chakra-ui/react/dist/esm/components/grid/grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/home/node/node_modules/@chakra-ui/react/dist/esm/components/link/link.js");
;
import(/* webpackMode: "eager" */ "/home/node/node_modules/@chakra-ui/react/dist/esm/components/skeleton/skeleton.js");
;
import(/* webpackMode: "eager", webpackExports: ["HStack"] */ "/home/node/node_modules/@chakra-ui/react/dist/esm/components/stack/h-stack.js");
;
import(/* webpackMode: "eager" */ "/home/node/node_modules/@chakra-ui/react/dist/esm/components/typography/heading.js");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/isRestoring.js");
;
import(/* webpackMode: "eager" */ "/home/node/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/home/node/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/home/node/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/home/node/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/home/node/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/node/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/components/ui/LucideIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/components/ui/QueryBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/AnnouncementSection/AnnouncementBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/BestSellersSection/BestSellersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/BlogSection/components/BlogList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/BlogSection/components/BlogSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/BrandCategoriesSection/BrandCategoriesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/CustomerTestimonialsSection/CustomerTestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/ExploreProductsSection/ExploreProductsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/MainBannerSection/MainBannerSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/ProductFinderSection/ProductFinderSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/RecentlyViewedSection/RecentlyViewedSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/ShopByCategorySection/ShopByCategorySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/TopRankedSection/TopRankedSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/TrendingNowSection/TrendingNowSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/containers/home/components/sections/WhySkinSeoulSection/WhySkinSeoulSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useReportWebVitals"] */ "/home/node/src/hooks/utils/useReportWebVitals.ts");
;
import(/* webpackMode: "eager", webpackExports: ["createSafeContext"] */ "/home/node/src/utils/react/createSafeContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/utils/react/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/src/utils/react/ImpressionArea.tsx");
